// extracted by mini-css-extract-plugin
export default {"wrapper":"Jp-z","response":"Kp-z","error":"Lp-z","disabled":"Mp-z","buttons":"Np-z","feedbackQuestionSection":"Op-z","yesNoWrapper":"Pp-z"};